import { Component, OnInit } from '@angular/core';

@Component({
  templateUrl: './sign-up.page.html',
  styleUrls: ['./sign-up.page.scss']
})
export class SignUpPage implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
